import { Component } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { Router } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  title: string = '';
  soilguardFeatures = environment.soilguardFeatures;

  constructor(public router: Router, public translate: TranslateService) {
    translate.setDefaultLang('en');
    translate.use('en');

    if (this.soilguardFeatures) {
      this.title = 'soilguardians';
    } else {
      this.title = 'agnes-dashboard';
    }
  }
}
